import { Avatar } from '@mui/material'
import TraicyAvatar from 'src/assets/images/traicy-avatar.png'

interface IProps {
  size?: string
  isActive?: boolean
}

const TraicyAgentIcon = ({ size, isActive }: IProps) => (
  <Avatar src={TraicyAvatar} sx={{ width: size ?? '24px', height: size ?? '24px' }} />
)

export default TraicyAgentIcon
